import {jwtAuthentication as authentication} from './jwtSignon';
import decodeJWT from 'jwt-decode'; 

export class JwtAuthentication {

  constructor() {
    authentication.initialize();
  }

  getAuthentication(){
    return authentication;
  }

  isB2C() {
    return authentication.isB2C()
    }
  
  isLoggedIn() {
    return authentication.isLoggedIn()
    }

  logout() {
    authentication.signOut();
  }

  getToken() {
    return authentication.getAccessToken();
  }

  setAccessToken(accessToken) {
    return authentication.setAccessToken(accessToken);
  }

  currentUser() {
    let token = authentication.getAccessToken();    
    const decoded = decodeJWT(token);    
    return decoded;
  }

  
  currentUserAsync(setUser) {
    authentication.getAccessTokenAsync(setUser);    
  }

  login() {
    authentication.login();
  }
  signUp() {
   //no op. login is federeated, maintained elsewhere
  }
  profile() {
   //no op. login is federeated, maintained elsewhere
  }
    
  

}

